import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-table-zero-results-message',
  templateUrl: './table-zero-results-message.component.html',
  styleUrl: './table-zero-results-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableZeroResultsMessageComponent {}
